import { render, staticRenderFns } from "./RoomInfo.vue?vue&type=template&id=b5b59764&"
import script from "./RoomInfo.vue?vue&type=script&lang=js&"
export * from "./RoomInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports